<template>
  <div id="showtable" class="speve_tbl">
    <template v-if="!selectedMatchAllBet">
      <!-- Today RB -->
      <!-- <template v-if="(selectedMarket=='1' && sortedRBEventList && Object.keys(sortedRBEventList).length > 0)">
        <todayHeader :marketType="market.inPlayMarket.key" @updateMethod="showMarketMatches"></todayHeader>
        <template v-if="showRBhideAll">
          <template v-for="(eventObj, eventObjKey) in sortedRBEventList">
            <div class="list-card-wrap v-scroll-item relative-position sticky-wrap" style="height: 38px !important; top: 73.5px;">
              <div class="list-card-inner" :key="eventObjKey">
                <div class="c-match-league match-tpl0-bg"
                  :class="checkClass(showRBLgeEve, eventObjKey)" @click="showLeg(eventObjKey, true)">
                  <div class="tr-match-head">
                    <div class="leagues-wrap"  style="width:700px;">
                      <i size="14px" class="icon-arrow q-icon c-icon"></i>
                      <div class="league-icon-wrap">
                      </div> 
                      <div class="ellipsis-wrap">
                        <div class="absolute-full">
                          <span class="ellipsis allow-user-select" :title="eventObj[0].lgecapt" v-html="eventObj[0].lgecapt"></span>
                          <span class="league-match-count">{{ eventObj.length }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="play-name vrow col">
                    </div>
                    <div class="yb-flex-center" style="width: 39px !important;">
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <template v-if="showRBLgeEve[eventObjKey]">
            <template v-if="!showRBLgeEve[eventObjKey].hide">
              <template v-for="(event, eventKey) in eventObj" v-if="eventKey!='hide'">
                <div class="list-card-wrap v-scroll-item relative-position evecardwrap" :id="'eCardWrap'+event.eveid" :ref="'eCardWrap'+event.eveid" :style="eventHeight(event, 'ecw', true)">
                    <div class="list-card-inner">
                      <div class="c-match-card relative-position evecard" :id="'eCard'+event.eveid" :ref="'eCard'+event.eveid" :style="eventHeight(event, 'ec', true)">
                        <div class="c-match-item match-tpl0-bg more-handicap csid-1">
                          <div class="process-col yb-flex-center">
                              <sportTime :event="event"></sportTime>
                          </div>
                          <div class="match-handicap-item-wrap match-handicap-item-wrap-simple">
                                  <div class="match-handicap-item">
                                      <div class="c-match-handicap c-match-handicap-simple" :id="'cmatch'+event.eveid">
                                        <div class="vrow no-wrap">
                                          <div class="handicap-col handicap-col-simple" :id="'handicapCol'+event.eveid+rhdpBetType+ftPlyType+subMatchKeyCap[0]">
                                              <div class="bet-item-wrap home" style="width: 100% !important;">
                                                  <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon" >
                                                      <div class="ellipsis-wrap">
                                                        <div class="vrow no-wrap absolute-full">
                                                            <div class="team-name home ellipsis allow-user-select" :title="event.tacapt" v-html="event.tacapt"></div>
                                                            <span class="red-ball" :style="{ display : (event.rbinfo && event.rbinfo.rca>0)? 'block':'none' }">
                                                            <template v-if="(event.rbinfo && event.rbinfo.rca>0)">
                                                                {{ event.rbinfo.rca }}
                                                            </template>
                                                            </span>
                                                        </div>
                                                      </div>
                                                      <odd :event="event" :team="teamA" :plyType="ftPlyType" :betType="rhdpBetType" :match="0" />
                                                  </div>
                                              </div>
                                              <div class="yb-flex-center" style="width: 20%;">
                                                  <div class="score">
                                                      <template v-if="(event.rbinfo && event.rbinfo.scoa>=0)">
                                                          {{ event.rbinfo.scoa }}
                                                      </template>
                                                  </div>
                                              </div>
                                              <template>
                                                  <div class="bet-item-wrap draw" style="width: 50% !important;">
                                                      <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                                          <div class="handicap-value color-highlight" style="justify-content: center; margin: 0 10px;">
                                                              <span class="handicap-more" style="display: none; width: min-content;">&nbsp;</span>
                                                              <div class="handicap-value-text">
                                                                  <handicap :event="event" :favTeam="'a'" :plyType="ftPlyType" :betType="rhdpBetType" :match="0" />
                                                              </div>
                                                          </div>
                                                      </div>
                                                  </div>
                                              </template>
                                              <div class="yb-flex-center" style="width: 20%;">
                                                  <div class="score">
                                                      <template v-if="(event.rbinfo && event.rbinfo.scob>=0)">
                                                          {{ event.rbinfo.scob }}
                                                      </template>
                                                  </div>
                                              </div>
                                              <div class="bet-item-wrap away" style="width: 100% !important;">
                                                  <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                                      <div class="ellipsis-wrap">
                                                        <div class="vrow no-wrap absolute-full">
                                                            <div class="team-name away ellipsis allow-user-select" :title="event.tbcapt" v-html="event.tbcapt"></div>
                                                            <span class="red-ball" :style="{ display : (event.rbinfo && event.rbinfo.rcb>0) ? 'block':'none' }">
                                                            <template v-if="(event.rbinfo && event.rbinfo.rcb>0)">
                                                                {{ event.rbinfo.rcb }}
                                                            </template>
                                                            </span>
                                                        </div>
                                                      </div>
                                                      <odd :event="event" :team="teamB" :plyType="ftPlyType" :betType="rhdpBetType" :match="0" />
                                                  </div>
                                              </div>
                                          </div>
                                        </div>
                                      </div>
                                  </div>
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
              </template>
            </template>
            </template>
          </template>
        </template>
      </template> -->

      <!-- Normal Match -->
      <!-- Today Not Started Match -->

      <template v-for="sc in section">
        <template v-if="(sortedEventList[sc] && sortedEventList[sc].length > 0)">
          <todayHeader :marketType="sc+'_sp'" @updateMethod="showMarketMatches(false,sc)"></todayHeader>
          <template v-if="hide_section[sc] === false">
            <template v-for="(eventObj, eventObjKey) in sortedEventList[sc]">
              <!-- League Capt -->
              <div class="list-card-wrap v-scroll-item relative-position sticky-wrap" style="height: 38px !important;" :style="getTop()">
                <div class="list-card-inner" :key="eventObjKey">
                  <div class="c-match-league match-tpl0-bg"
                    :class="checkClass(showLgeEve, eventObjKey, sc)" @click="showLeg(eventObjKey, false, sc)">
                    <div class="tr-match-head">
                      <div class="leagues-wrap" style="width:700px;">
                        <i size="14px" class="icon-arrow q-icon c-icon"></i>
                        <div class="league-icon-wrap">
                          <!-- <img data-team="undefined" data-csid="undefined" src="https://image.gredfged.com/group1/M00/00/45/CgURtV8zqyaAYjn2AAAMpJixGIo955.png" style="opacity: 1;"> -->
                        </div>
                        <div class="ellipsis-wrap">
                          <div class="absolute-full" :title="eventObj[0].lgecapt">
                            <span class="ellipsis allow-user-select" :title="eventObj[0].lgecapt" v-html="eventObj[0].lgecapt"></span>
                            <span class="league-match-count">{{ eventObj.length }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="play-name vrow col">
                      </div>
                      <div class="yb-flex-center" style="width: 39px !important;">
                        <!-- <div class="icon-wrap m-star-wrap-league"
                          :class="{ added: eventObj[0].isFavourite }" @click="favourite(eventObj[0], true)">
                          <i class=" icon-star q-icon c-icon"
                            :class="{ active: eventObj[0].isFavourite }"></i>
                        </div> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- League Events -->
              <template v-if="showLgeEve[eventObjKey]">
              <template v-if="!isHidden(eventObjKey, sc)">
                <template v-for="(event, eventKey) in eventObj">
                  <div class="list-card-wrap v-scroll-item relative-position evecardwrap" :id="'eCardWrap'+event.eveid" :ref="'eCardWrap'+event.eveid" :style="eventHeight(event, 'ecw', false)">
                    <div class="list-card-inner">
                      <div class="c-match-card relative-position evecard" :id="'eCard'+event.eveid" :ref="'eCard'+event.eveid" :style="eventHeight(event, 'ec', false)">
                          <div class="c-match-item match-tpl0-bg more-handicap csid-1">
                            <div class="process-col yb-flex-center">
                                <sportTime :event="event"></sportTime>
                            </div>
                            <div class="match-handicap-item-wrap match-handicap-item-wrap-simple">
                                <!-- <template v-for="(subMatch, subMatchKey) in (event.sub + 1)" v-if="showSubMatch(subMatch, event, subMatchKey, true)"> -->
                                    <div class="match-handicap-item">
                                        <div class="c-match-handicap c-match-handicap-simple" :id="'cmatch'+event.eveid">
                                        <div class="vrow no-wrap">
                                            <!-- FT R1X2 -->
                                            <div class="handicap-col handicap-col-simple" :id="'handicapCol'+event.eveid+event.bettype_id+ftPlyType+subMatchKeyCap[0]">
                                                <div class="bet-item-wrap home" style="width: 100% !important;">
                                                    <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon" >
                                                        <div class="ellipsis-wrap">
                                                        <div class="vrow no-wrap absolute-full">
                                                            <div class="team-name home ellipsis allow-user-select" :title="event.tacapt" v-html="event.tacapt"></div>
                                                            <!-- <span class="red-ball" :style="{ display : (event.rbinfo && event.rbinfo.rca>0)? 'block':'none' }">
                                                            <template v-if="(event.rbinfo && event.rbinfo.rca>0)">
                                                                {{ event.rbinfo.rca }}
                                                            </template>
                                                            </span> -->
                                                        </div>
                                                        </div>
                                                        <odd :event="event" :team="teamA" :plyType="ftPlyType" :betType="event.bettype_id" :match="0" />
                                                    </div>
                                                </div>
                                                <div class="yb-flex-center" style="width: 20%;">
                                                    <div class="score">
                                                        <template v-if="(event.score_a && event.score_a>=0)">
                                                            {{ event.score_a }}
                                                        </template>
                                                    </div>
                                                </div>
                                                <template>
                                                    <div class="bet-item-wrap draw" style="width: 50% !important;">
                                                        <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                                            <div class="handicap-value color-highlight" style="justify-content: center; margin: 0 10px;">
                                                                <span class="handicap-more" style="display: none; width: min-content;">&nbsp;</span>
                                                                <div class="handicap-value-text">
                                                                    <handicap :event="event" :favTeam="'a'" :plyType="ftPlyType" :betType="event.bettype_id" :match="0"  v-if="event.bettype_id == '1'"/>
                                                                    <span v-else>VS</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </template>
                                                <div class="yb-flex-center" style="width: 20%;">
                                                    <div class="score">
                                                        <template v-if="(event.score_b && event.score_b>=0)">
                                                            {{ event.score_b }}
                                                        </template>
                                                    </div>
                                                </div>
                                                <div class="bet-item-wrap away" style="width: 100% !important;">
                                                    <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                                        <div class="ellipsis-wrap">
                                                        <div class="vrow no-wrap absolute-full">
                                                            <div class="team-name away ellipsis allow-user-select" :title="event.tbcapt" v-html="event.tbcapt"></div>
                                                            <!-- <span class="red-ball" :style="{ display : (event.rbinfo && event.rbinfo.rcb>0) ? 'block':'none' }">
                                                            <template v-if="(event.rbinfo && event.rbinfo.rcb>0)">
                                                                {{ event.rbinfo.rcb }}
                                                            </template>
                                                            </span> -->
                                                        </div>
                                                        </div>
                                                        <odd :event="event" :team="teamB" :plyType="ftPlyType" :betType="event.bettype_id" :match="0" />
                                                    </div>
                                                </div>
                                                <!-- <div class="yb-flex-center" style="width: 30%;">
                                                    <div class="play-count-wrap vrow no-wrap">
                                                        <span class="play-count" style="margin-right: 5px;" @click="enterAllBet(event,3,false)">+{{ countAllBet(event) }}</span>
                                                        <span class="yb-flex-center">
                                                            <div class="yb-icon-arrow"></div>
                                                        </span>
                                                    </div>
                                                </div> -->
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                <!-- </template> -->
                            </div>
                            <div class="media-col media-col-simple">
                              <div class="media-col-wrap" style="justify-content: center !important;">
                                  <!-- <div class="icon-wrap">
                                      <span class="yb-flex-center yb-hover-bg m-star-wrap-match" @click="favourite(event, true)">
                                      <i aria-hidden="true" class="icon-star q-icon c-icon" :class="{'active': event.isFavourite}"></i>
                                      </span>
                                  </div>
                                  <div class="icon-wrap after_tpl0 relative-position" :class="{ active: (firstEventEveid== event.eveid && livetvEveid!= event.eveid) }">
                                      <div class="v-icon switch-icon" @click="enterAllBet(event,1,isRB)" :class="{ active:  (firstEventEveid== event.eveid && livetvEveid!= event.eveid) }" :title="sportAllBetLang['ALL_BET.LBL_SCORE_BOAD']"></div>
                                  </div>
                                  <div class="yb-flex-center"></div> -->
                                  <div data-v-5a29cfce="" class="icon-wrap relative-position" v-if="event.stream_url"> 
                                      <div data-v-5a29cfce="" class="v-icon video-icon"  @click="openSpecialStream(event.stream_url)" :title="sportAllBetLang['ALL_BET.LBL_ORIGINAL_VIDEO']"></div>
                                  </div>
                              </div>
                            </div>
                          </div>
                      </div>
                    </div>
                  </div>
                </template>
              </template> <!-- END League Events -->
              </template> 
            </template> <!-- END sortedEventList -->
          </template>
        </template>
      </template>

    </template>

    <div class="" v-if="(sortedEventList['today'] && Object.keys(sortedEventList['today']).length > 0) && (sortedEventList['early'] && Object.keys(sortedEventList['early']).length > 0)">
      <div style="text-align: right;color: var(--qq--y0-text-color5);font-weight: 550;font-size: 14px;"><span v-html="lang.sp_alert"></span></div>
      <div style="height: 15px;"></div>
      <div class="pager-wrap vrow justify-end">
        <div class="go-top-btn yb-flex-center" @click="backtoTop">
          <i aria-hidden="true" role="presentation" class="q-icon icon-go_top c-icon" style="font-size: 14px;"></i>
          <div class="vmsg">{{ lang.sportAllBet['ALL_BET.BACK_TOP'] }}</div>
        </div>
      </div>
    </div>
    <div class="absolute-full resize-observer-wrap">
      <div class="absolute-full expand"></div>
      <div class="absolute-full shrink"></div>
    </div>
  </div>
</template>
<script>
import {
  mapGetters
} from 'vuex'
import EventBus from '../../events/event-bus'

// import DateFilter from '@/vue/filters/date'
// import moment from 'moment'

// import OddComponents from '../../components/odd'
// import Odd1x2Components from '../../components/odd1x2'
// import HandicapComponents from '../../components/handicap'
// import OverUnderComponents from '../../components/over-under'
import sportTime from './sportTimeColumn'
import sportTeam from './sportTeamColumn'
import soccerAllCommon from './soccerAllCommon'
import moreBetComponent from './allBet/more-bet'
import todayHeader from './todayHeader'
import simpleSoccer from './simpleSoccer'

import allBetMixin from '@/vue/mixins/allBet'
import sportFavourite from '@/vue/mixins/favourite'

export default {
  mixins: [allBetMixin, sportFavourite],
  components: {
    moreBetComponent,
    soccerAllCommon,
    sportTime,
    sportTeam,
    todayHeader,
    simpleSoccer,
  },
  computed: {
    ...mapGetters([
      'sportTableLang',
      'sportAllBetLang',
      'sortedEventList',
      // 'sortedRBEventList',
      'sortedFavRbEventList',
      'market',
      'selectedShow',
      'selectedMarket',
      'selectedBettype',
      'selectedAllBetNew',
      'selectedMatchAllBet',
      'moreBetLoading',
      'tvIconFlag',
      'favouriteLgeEvents',
      'showFavEvents',
      'show_Unfold',
      'unfold_AllSc',
      'frameWidthHeight',
      'livetv',
      'firstEvent',
      'account',
      'showRBLgeEve',
      'showLgeEve',
      'isParlayTab',
      'isGameBannerSelected',
      'simpleSport',
      'specialEvent',
    ]),
    livetvEveid: {
      get() {
        return this.$store.getters.livetv.eveid;
      }
    },
    firstEventEveid:{ 
      get() {
        let ft=this.$store.getters.firstEvent
        return Object.keys(ft).length>0 ? ft.eveid:0
      }
    },
    widthColumn: {
      get() {
        var fm = this.$store.getters.frameWidthHeight
        var pageCenter = fm.width.CenterPage_current;
        var betBoxWidthMin = fm.leagueTeam.betBoxWidthMin;
        var betBoxWidthMax = fm.leagueTeam.betBoxWidthMax;
        var leagueBoxWidthMin = fm.leagueTeam.leagueBoxWidthMin;
        var league = leagueBoxWidthMin;
        var team = betBoxWidthMin;
        var timeColumn = fm.leagueTeam.timeColumn;
        var favColumn = fm.leagueTeam.favColumn;
        var columnCount =fm.leagueTeam.columnCountBet;
        var columnCountBetShow =fm.leagueTeam.columnCountBetShow;
        var sprt = this.$store.getters.selectedBettype.sprtId
        var tmp = this.$store.getters.selectedBettype.tmpltId
        var hideCol=0;
        
        if(!_.isUndefined(this.$store.getters.unfold_AllSc[sprt]) && !_.isUndefined(this.$store.getters.unfold_AllSc[sprt][tmp]) && this.$store.getters.unfold_AllSc[sprt][tmp]){
          if(pageCenter<=1370){
            columnCountBetShow-=1;
            hideCol+=1;
          }
          if(pageCenter<1280){
            columnCountBetShow-=1;
            hideCol+=1;
          }
          columnCount=columnCountBetShow;
        }
        var AvailableLT = pageCenter-timeColumn-favColumn-(betBoxWidthMin*columnCount)-leagueBoxWidthMin;   
        if(AvailableLT>0){
          let TeamCal = AvailableLT * 0.7;
          team=betBoxWidthMin+(TeamCal/columnCount);
          team= Math.floor(team);
          if(team<betBoxWidthMin){
            team=betBoxWidthMin
          }else if(team>betBoxWidthMax){
            team=betBoxWidthMax;
          }
          let caladd = team-betBoxWidthMin
          if(caladd>0){
            AvailableLT = AvailableLT -((team-betBoxWidthMin)*columnCount)
            if(AvailableLT>0){
              league = AvailableLT+leagueBoxWidthMin
            }
          }else{
            league = AvailableLT+leagueBoxWidthMin
          }
        }else{
          league = AvailableLT+leagueBoxWidthMin
        }
        league=league-15; // minus scroll width + border use
        var league2=league+timeColumn
        return [league,team, league2,hideCol] // Team column , team column , league title
      },
    },
    sortedRBEventList: function() {
      return this.$store.getters.sortedRBEventList
      // if(!this.showFavEvents){
      //   return this.$store.getters.sortedRBEventList
      // } else {
      //   return this.$store.getters.sortedFavRbEventList
      // }
    },
  },
  data() {
    return {
      selectedLang: window._langid,
      lang: window.lang,
      // moreBetTab: [allBetMixin.data().rcsBetType], 
      moreBetEveId: null,
      showhideAll: true,
      showRBhideAll: true,
      reloadingPer: '0 %',
      showLimit: 6,
      isUnfold: false,
      hide_section: {'today': false, 'early': false},
      section: ['today', 'early'],
      hide_lg: {},
      subMatchKeyCap: {
        0: 'a',
        1: 'b',
        2: 'c',
        3: 'd'
      }
    }
  },
  watch : {
    unfold_AllSc: {
      handler: function (val, oldVal) {
        this.checkUnfold()
      },
      deep: true
    }
  },
  beforeMount() {
    this.checkUnfold()
  },
  mounted() {
    // this.showhideAll = true;
    EventBus.$on('moreBetLoading', ((params) => {
      this.reloadingPer = '75 %';
    }).bind(this))
    
  },
  methods: {
    checkClass(LgeEve, eventObjKey, section) {
      let match = '';
      let leagues = '';

      const eventObj = LgeEve[eventObjKey];
      const sectionHidden = this.hide_lg || [];
      if (Object.keys(sectionHidden).length > 0) {
        // Only hide if this ID exists in the section
        if (sectionHidden[section] != undefined && sectionHidden[section].indexOf(eventObjKey) >= 0) {
          leagues = 'leagues-pack';
          match = '';
        } else {
          match = 'match-tpl0';
          leagues = '';
        }
      } else {
        // First load: use LgeEve.hide
        if (eventObj && !_.isUndefined(eventObj.hide)) {
          leagues = eventObj.hide ? 'leagues-pack' : '';
          match = !eventObj.hide ? 'match-tpl0' : '';
        }
      }
      return match + ' ' + leagues;
    },
    isHidden(eventObjKey, section) {
      const sectionHidden = this.hide_lg || {};
      const eventObj = this.showLgeEve[eventObjKey];
      var res = true;

      if (Object.keys(sectionHidden).length > 0) {
        // Only hide if this ID exists in the section
        if (sectionHidden[section] != undefined && sectionHidden[section].indexOf(eventObjKey) >= 0) {
          res = true;
        } else {
          res = false;
        } 
      } else {
        // First load: use LgeEve.hide
        if (eventObj && typeof eventObj.hide !== 'undefined') {
          res = eventObj.hide;
        }
      }
      return res;
    },
    getSMKey(smKey){
      var smKeyId = ''
      if (smKey == 0 || smKey == 'a') {
        smKeyId = 'a'
      } else if (smKey == 1 || smKey == 'b') {
        smKeyId = 'b'
      } else if (smKey == 2 || smKey == 'c') {
        smKeyId = 'c'
      } else {
        smKeyId = 'd'
      }
      return smKeyId
    },
    checkUnfold(){
      var sprt = this.selectedBettype.sprtId
      var tmp = this.selectedBettype.tmpltId
      if(!_.isUndefined(this.unfold_AllSc[sprt]) && !_.isUndefined(this.unfold_AllSc[sprt][tmp])){
        this.isUnfold = this.unfold_AllSc[sprt][tmp]
      }
    },
    getTop(){
      var topVal = (this.selectedMarket == this.$store.getters.market.tdyMarket.key  && (this.$store.getters.selectedBettype.betTypId != 5 || !this.isParlayTab)) ? '73.5' : '89.5'
      if((this.isGameBannerSelected || this.specialEvent) && this.selectedMarket == this.$store.getters.market.earlyMarket.key){
        topVal = '37.5'
      }

      return 'top:'+topVal+'px'
    },
    showMarketMatches(isRB, section) {
      this.hide_section[section] = !this.hide_section[section]
      if (isRB) {
        this.showRBhideAll = !this.showRBhideAll
      } else {
        this.showhideAll = !this.showhideAll
      }
    },
    showhideMain(isRB) {
      var key = ''
      if (!isRB) {
        this.showhideAll = (this.showhideAll) ? false : true;
        for (key in this.sortedEventList['today']) {
          this.$set(this.sortedEventList['today'][key], 'hide', !this.showhideAll)
        }
      }
      if (this.showFavEvents && isRB) {
        this.showRBhideAll = (this.showRBhideAll) ? false : true;
        // if (this.showFavEvents) {
        //   for (key in this.sortedFavRbEventList) {
        //     this.$set(this.sortedRBEventList[key], 'hide', !this.showRBhideAll)
        //     // this.$set(this.sortedFavRbEventList[key], 'hide', !this.showRBhideAll)
        //   }
        // }
      }
    },
    showLeg(key, isRB, section) {
      if (!this.hide_lg[section]) {
        this.$set(this.hide_lg, section, []);
      }

      const index = this.hide_lg[section].indexOf(key);
      if (index >= 0) {
        this.hide_lg[section].splice(index, 1);
      } else {
        // add
        this.hide_lg[section].push(key);
      }

      if (!isRB) {
        this.$set(this.showLgeEve[key], 'hide', !this.showLgeEve[key].hide)
        // this.$set(this.sortedEventList[key], 'hide', !this.sortedEventList[key].hide)
      } else if (isRB) {
        this.$set(this.showRBLgeEve[key], 'hide', !this.showRBLgeEve[key].hide)
        // this.$set(this.sortedRBEventList[key], 'hide', !this.sortedRBEventList[key].hide)
      }

      //if (this.showFavEvents && isRB) {
      //  this.$set(this.sortedFavRbEventList[key], 'hide', !this.sortedFavRbEventList[key].hide)
      //}
    },
    countAllBet(event, selectedShow) {
      var countCv = event.all
      if (event.od) {
        $.each(event.od, function (plyTypes, drawBt) {
          if (selectedShow == 3 && plyTypes == 2) {
          } else if (selectedShow == 4 && plyTypes == 1) {
          } else {
            $.each(drawBt, function (bidx, drawDual) {
              if (bidx == 1 || bidx == 2 || bidx == 8 || bidx == 9) {
                $.each(drawDual, function (dd, val) {
                  --countCv;
                });
              } else if (bidx == 4 || bidx == 11) {
                if (selectedShow == 2) {
                  --countCv;
                }
              }
            });
          }
        });
      }
      return countCv;
    },
    enterMatch(event) {
      this.$store.dispatch('getMatchAllBet', {
        event: event,
        token: token.arr_8,
      })
    },
    enterAllBet(event,startTv, isRB=false) {
      this.$store.commit('SHOW_UNFOLD', true)
      this.$store.commit('SHOW_FOLD', false)
      this.$store.commit('UNFOLD_ALLSC', false)
      if(this.$store.getters.account.previewFlag && !this.$store.getters.isLiveOn){
        if (window._hasRedirect && startTv == 2) {
          $('.login-redirect-dialog').show();
          return false;
        }
        startTv=1;
      }
      this.$store.dispatch('getMatchAllBet', {
        event: event,
        isRB: isRB,
        // isRB: (event.rbstatus==1) ? true : false,
        token: token.arr_8,
        loadTemplate: startTv  // 1 open right score board only, 2 open live tv, 3 open right score board + all bet, 0 all bet only
      })
      if(startTv == 1){
        this.$store.commit('RIGHT_BOARD_CHG', event)
      }
    },
    backtoTop() {
      // $(".list-scrollbar").animate({ scrollTop: 0 },100);
      $(".sport-table-scroll").animate({ scrollTop: 0 },100);
    },
    openSpecialStream(url) {
      let height = window.screen.availHeight - 50;
      let width = window.screen.availWidth - 100;
      var left = (screen.width/2)-(width/2);
      var top = (screen.height/2)-(height/2);
      if (width > 1024) {
          width = 1024;
      }
      if(height>600){
          height=600
      }
      window.open(url, "MsgWindow", "width=" + width + ", height=" + height + ", top="+top+", left="+left+", resizable=yes, scrollbars=yes");
    },
  },
  updated() { 
    $('.ellipsis').bind('mouseenter', function(){
        var $this = $(this);
        if(this.offsetWidth < this.scrollWidth && !$this.attr('title')){
            $this.attr('title', $this.text());
        }
    });
  },
  beforeDestroy() {
    this.$store.commit('SHOW_RBLGEEVE', [])
    this.$store.commit('SHOW_LGEEVE', {})
  },
  destroyed() {
    EventBus.$off('moreBetLoading')
    
  },
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// resources/wob/vue/apps/sport/specialEventCommon.vue